// Core packages
import { Component, Inject, OnInit } from '@angular/core';

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

// Custom packages

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss']
})
export class VideoDialogComponent implements OnInit {
  messageOnly = false;
  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
  ) {
    
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit() {
    // Set default icons if none are provided
    if (!this.data.btnCancelIcon) {
      this.data.btnCancelIcon = 'fa-times-circle';
    }

    // Set default button colors if none are provided
    if (!this.data.btnCancelColor) {
      this.data.btnCancelColor = 'warn';
    }

    if (!this.data.btnCancelText) {
      this.data.btnCancelText =  this.translateService.instant('common.cta.close');
    }
  }

  /**
   * Handle click on Denial button
   *
   * @since 1.0.0
   */
  onDenial(): void {
    this.dialogRef.close(false);
  }
}
